import script from "./PropertyRatingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyRatingCard.vue?vue&type=script&setup=true&lang=js"

import "./PropertyRatingCard.vue?vue&type=style&index=0&id=56c4649c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c4649c"]])

export default __exports__